import { useMutation } from '@tanstack/react-query';
import { notifications } from '@mantine/notifications';
import { useTranslation } from 'react-i18next';
import { LifeEventsApi } from '../../../apis/LifeEventsApi/LifeEventsApi';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { AppMedError } from '../../../error/AppMedError';

export interface ISendLifeEventsToAssistantVariables {
    patientId: string;
    language: string;
}

export function useSendLifeEventsToAssistant() {
    const { t } = useTranslation();

    return useMutation<{ assistantName: string; assistantEmail: string }, AppMedError, ISendLifeEventsToAssistantVariables>({
        mutationKey: [QueryKeys.lifeEvents, 'sendToAssistant'],
        mutationFn: async ({ patientId, language }) => {
            return await LifeEventsApi.sendLifeEventsToAssistant(patientId, language);
        },
        onSuccess: (data) => {
            notifications.show({
                title: t('lifeEventsHistory.notifications.sendToAssistantSuccess.title'),
                message: t('lifeEventsHistory.notifications.sendToAssistantSuccess.message', {
                    name: data.assistantName || data.assistantEmail,
                }),
                color: 'green',
            });
        },
        onError: (error: AppMedError) => {
            notifications.show({
                title: t('lifeEventsHistory.notifications.sendToAssistantError.title'),
                message: error?.message || t('lifeEventsHistory.notifications.sendToAssistantError.message'),
                color: 'red',
            });
        },
    });
}
